<template>
    <article :class="bodyClass">
        <aside :class="asideClass">
            <slot name="aside"></slot>
        </aside>

        <main class="page-split__main" :class="spacingClass">
            <slot name="main"></slot>
        </main>
    </article>
</template>

<script>
    export default {
        props: {
            type: { type: String, default: 'row' },
            spacing: { type: String, default: 'small' },
            hasBorder: { type: Boolean, default: false },
            position: { type: String, default: 'center' },
        },

        computed: {
            bodyClass() {
                return {
                    'page-split': true,
                    'page-split--has-border': this.hasBorder,
                    [`page-split--type-${this.type}`]: true,
                    [`page-split--position-${this.position}`]: true,
                }
            },

            asideClass() {
                return {
                    'page-split__aside': true,
                    [`page-split__aside--position-${this.position}`]: true,
                    ...this.spacingClass,
                }
            },

            spacingClass() {
                return {
                    [`page-split__spacing--${this.spacing}`]: true,
                }
            },
        },
    }
</script>
